import { IModel } from "@/@types/models/model";

import { commonFields } from "./helpers/commonFields"; 

const KomunalneObveze: IModel = {
  title: "Komunalne obveze",
  source: "komunalne_obveze",
  apiPath: "projekti/{$projekt_id}/komunalne-obveze",
  forms: {
    default: {
      fields: ["id"],
    },
    zapisnici: {
      fields: ["export_mode"],
    },
    xml: {
      fields: ["xml"]
    },
    insert: {
      fields: ["lokacija_id", "obveznik", "oib", "naselje_obveznika", "adresa_obveznika", "status_obv", "komentar"]
    }
  },
  listViews: {
    "default": {
      fields: [
        "id",
        "obveznik",
        "lokacija_id",
        "naselje_objekta",
        "adresa_objekta",
        "status_obv",
        "zona",
        "zapisnik"
      ],
      hidden: ["ulica_kbr"]
    },
    "radni_sastanci": {
      fields: [
        "cut_id",
        "obveznik",
        "lokacija_id",
        "naselje_objekta",
        "adresa_objekta",
        "oib",
        "status_obv",
        "vrsta_prostora_parsed",
        "adr_nas_obveznika",
        "zona",
        "p_a",
        "p_b",
        "komentar"
      ],
      hidden: ["id"]
    },
    exportExcel: {
      fields: [
        "id",
        "obveznik",
        "lokacija_id",
        "naselje_objekta",
        "adresa_objekta",
        "oib",
        "status_obv",
        "adr_nas_obveznika",
        "zona",
        "p_a",
        "p_b",
        "komentar"
      ]
    },
    "zapisnici": {
      fields: [
        "id",
        "obveznik",
        "lokacija_id",
        "fishnet",
        "naselje_objekta",
        "adresa_objekta",
        "status_obv",
        "zona",
        "zapisnik"
      ],
      hidden: ["ulica_kbr"]
    }
  },
  fields: [
    {
      title: "id",
      source: "id",
      ttoken: "komunalne_obveze.kn_id",
      type: "text",
      idattr: true,
      readonly: true,
    },
    {
      title: "cut_id",
      source: "cut_id",
      ttoken: "common.id",
      tooltip: "common.id",
      type: "text",
      readonly: true
    },
    {
      title: "Naziv obveznika",
      source: "obveznik",
      ttoken: "komunalne_obveze.naziv_obveznika",
      type: "text"
    },
    {
      title: "OIB",
      source: "oib",
      ttoken: "common.oib",
      type: "text"
    },
    {
      title: "Adresa obveznika",
      source: "adresa_obveznika",
      ttoken: "komunalne_obveze.adresa_obveznika",
      type: "text"
    },
    {
      title: "Sifra obveznika",
      source: "sifra_obveznika",
      ttoken: "komunalne_obveze.sifra_obveznika",
      type: "text"
    },
    {
      title: "Naselje obveznika",
      source: "naselje_obveznika",
      ttoken: "komunalne_obveze.naselje_obveznika",
      type: "text"
    },
    {
      title: "Adresa i naselje obveznika",
      source: "adr_nas_obveznika",
      ttoken: "komunalne_obveze.adr_nas_obveznika",
      type: "text"
    },
    {
      title: "Ulica obveznika",
      source: "ulica_obveznika",
      ttoken: "komunalne_obveze.ulica_obveznika",
      type: "text"
    },
    {
      title: "Kucni broj objekta",
      source: "kb_objekta",
      ttoken: "komunalne_obveze.kb_objekta",
      type: "text"
    },
    {
      title: "Lokacija ID",
      source: "lokacija_id",
      ttoken: "komunalne_obveze.lok",
      type: "text"
    },
    {
      title: "Naselje objekta",
      source: "naselje_objekta",
      ttoken: "komunalne_obveze.naselje_objekta",
      type: "text"
    },
    {
      title: "Ulica KBR",
      source: "ulica_kbr",
      ttoken: "komunalne_obveze.ulica_kbr",
      type: "text"
    },
    {
      title: "Adresa Objekta",
      source: "adresa_objekta",
      ttoken: "komunalne_obveze.ulica_kbr",
      type: "text"
    },
    {
      title: "Broj zapisnika",
      source: "zapisnik",
      ttoken: "komunalne_obveze.zapisnik_id",
      type: "text"
    },
    {
      title: "Namjena ID",
      source: "namjena_id",
      ttoken: "komunalne_obveze.namjena_id",
      type: "numeric"
    },
    {
      title: "Povrsina A",
      source: "p_a",
      ttoken: "komunalne_obveze.p_a",
      type: "numeric"
    },
    {
      title: "Povrsina B",
      source: "p_b",
      ttoken: "komunalne_obveze.p_b",
      type: "numeric"
    },
    {
      title: "Povrsina C",
      source: "p_c",
      ttoken: "komunalne_obveze.p_c",
      type: "numeric"
    },
    {
      title: "Zona",
      source: "zona",
      ttoken: "komunalne_obveze.zona",
      type: "text"
    },
    {
      title: "Projekt ID",
      source: "projekt_id",
      ttoken: "komunalne_obveze.projekt_id",
      type: "numeric"
    },
    {
      title: "XML",
      source: "xml",
      ttoken: "common.xml",
      type: "multiline",
      rows: 25,
      maxRows: 25,
      readonly: true
    },
    {
      title: "Status obveznika",
      source: "status_obv",
      ttoken: "komunalne_obveze.status_obv",
      type: "numeric"
    },
    {
      title: "Odaberi nacin prikupljanja podataka za export",
      source: "export_mode",
      ttoken: "komunalne_obveze.export_mode",
      type: "radio",
      translate: true,
      validation: {
        required: true
      },
      items: {
        labels: [
          "komunalne_obveze.export_modes.old",
          "komunalne_obveze.export_modes.new"
        ],
        values: ["old", "new"],
        default: "old"
      }
    },
    {
      title: "Komentar",
      source: "komentar",
      ttoken: "common.komentar",
      type: "text",
      sort: true
    },
    { // fishnet od lokacije vezane na komunalnu obvezu
      title: "fishnet",
      source: "fishnet",
      sort: true,
      filter: true,
      ttoken: "objekti.fishnet",
      type: "numeric"
    },
    {
      title: "Vrsta prostora",
      source: "vrsta_prostora",
      ttoken: "objekti.vrsta_prostora",
      type: "numeric",
      readonly: true
    },
    {
      title: "Vrsta prostora parsed ",
      source: "vrsta_prostora_parsed",
      ttoken: "objekti.vrsta_prostora",
      type: "text",
      readonly: true
    },
    commonFields.wkt
  ]
};

export default KomunalneObveze;
